<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.2);"
    *ngIf="showToast">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content border-0 shadow rounded-4 overflow-hidden">
            <div class="modal-header py-3 px-4 d-flex justify-content-between align-items-center">
                <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
            </div>
            <div class="modal-body text-center p-4">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <!-- <p class="fs-5 mb-0 icon" [ngClass]="textClass">{{ icon}}</p> -->
                    <img [src]="imageAsset" width="78px" height="78px">
                    <p class="mb-0 toast-message">{{ toastData.message }}</p>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showToast"></div>